import Route from '@ember/routing/route';
import { ajax } from 'discourse/lib/ajax';

export default class AdminPluginsProxyviewsSeoRoute extends Route {
  async model() {
    try {
      const [
        guidesData,
        comparisonsData,
        robotsData,
        sitemapData,
        bestForData,
        alternativesData,
      ] = await Promise.allSettled([
        ajax('/admin/plugins/proxyviews-seo/guides'),
        ajax('/admin/plugins/proxyviews-seo/comparisons'),
        ajax('/admin/plugins/proxyviews-seo/robots'),
        ajax('/admin/plugins/proxyviews-seo/sitemap'),
        ajax('/admin/plugins/proxyviews-seo/best-for'),
        ajax('/admin/plugins/proxyviews-seo/alternatives'),
      ]);
      return {
        guidesData: guidesData.status === 'fulfilled' ? guidesData.value : {},
        comparisonsData: comparisonsData.status === 'fulfilled' ? comparisonsData.value : {},
        robotsData: robotsData.status === 'fulfilled' ? robotsData.value : {},
        sitemapData: sitemapData.status === 'fulfilled' ? sitemapData.value : {},
        bestForData: bestForData.status === 'fulfilled' ? bestForData.value : {},
        alternativesData: alternativesData.status === 'fulfilled' ? alternativesData.value : {},
      };
    } catch (e) {
      return {
        guidesData: {},
        comparisonsData: {},
        robotsData: {},
        sitemapData: {},
        bestForData: {},
        alternativesData: {},
      };
    }
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.guides = model.guidesData.guides || [];
    controller.guidesMeta = model.guidesData.meta || {};
    controller.guidesPage = 1;
    controller.categories = model.guidesData.categories || [];
    controller.baseCategories = model.guidesData.base_categories || [];
    controller.customCategories = model.guidesData.custom_categories || [];
    controller.comparisons = model.comparisonsData.comparisons || [];
    controller.comparisonsMeta = model.comparisonsData.meta || {};
    controller.comparisonsPage = 1;
    controller.robotsEnabled = !!model.robotsData.robots.enabled;
    controller.robotsCustomRules = model.robotsData.robots.custom_rules || '';
    controller.robotsPreview = model.robotsData.robots.preview || '';
    controller.robotsUpdatedAt = model.robotsData.robots.updated_at || null;
    controller.robotsUpdatedBy = model.robotsData.robots.updated_by || null;
    controller.sitemapEnabled = !!model.sitemapData.sitemap.enabled;
    controller.sitemapUrl = model.sitemapData.sitemap.sitemap_url || '';
    controller.sitemapLastGeneratedAt = model.sitemapData.sitemap.last_generated_at || null;
    controller.sitemapUrlCount = model.sitemapData.sitemap.url_count || null;

    controller.bestForUseCases = model.bestForData.use_cases || [];
    controller.alternatives = model.alternativesData.alternatives || [];
  }
}
